"use client"
/* */
import { makeObservable, action, observable } from 'mobx';
import { useSelector } from '../../mobx/useSelector.mjs';
import { useStatic } from '../../hooks/useStatic.mjs';

class OverlayController {
  isOpen = false;
  onOpenHandlers = /* @__PURE__ */ new Set();
  onCloseHandlers = /* @__PURE__ */ new Set();
  constructor(options) {
    makeObservable(this, {
      isOpen: observable,
      open: action.bound,
      close: action.bound,
      toggle: action.bound,
      setOpen: action.bound
    });
    this.isOpen = options?.isDefaultOpen ?? false;
    if (options?.onOpen) {
      this.onOpenHandlers.add(options.onOpen);
    }
    if (options?.onClose) {
      this.onCloseHandlers.add(options.onClose);
    }
  }
  static useNew(options) {
    return useStatic(() => new OverlayController(options));
  }
  addOnOpen(handler) {
    this.onOpenHandlers.add(handler);
    return () => {
      this.onOpenHandlers.delete(handler);
    };
  }
  addOnClose(handler) {
    this.onCloseHandlers.add(handler);
    return () => {
      this.onCloseHandlers.delete(handler);
    };
  }
  executeOnClose() {
    this.onCloseHandlers.forEach((handler) => handler());
  }
  executeOnOpen() {
    this.onOpenHandlers.forEach((handler) => handler());
  }
  open() {
    this.isOpen = true;
    this.executeOnOpen();
  }
  close() {
    this.isOpen = false;
    this.executeOnClose();
  }
  toggle() {
    this.isOpen = !this.isOpen;
    if (this.isOpen) {
      this.executeOnOpen();
    } else {
      this.executeOnClose();
    }
  }
  setOpen(to) {
    this.isOpen = to;
    if (to) {
      this.executeOnOpen();
    } else {
      this.executeOnClose();
    }
  }
  useIsOpen() {
    return useSelector(() => this.isOpen);
  }
}

export { OverlayController };
//# sourceMappingURL=OverlayController.mjs.map
